import { Box, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
// import { tokens } from "../../../../../theme";
import { tokens } from "../../../../../theme";

import Text from "../../../../../components/theme/text/Text";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";

import { QuestionMarkOutlined } from "@mui/icons-material";
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from "react-i18next";
import { useSearchParams } from 'react-router-dom';
import MpAddWebshop from "../../../../../components/global/ModalsProgression/MpAddWebshop/MpAddWebshop";
import MpAmazonOAuthFinalize from "../../../../../components/global/ModalsProgression/MpAmazonOAuthFinalize/MpAmazonOAuthFinalize";
import MpTikTokOAuthFinalize from "../../../../../components/global/ModalsProgression/MpTikTokOAuthFinalize/MpTikTokOAuthFinalize";
import { config } from "../../../../../newapi/apiUrlConfig";
import { useExchangeTikTokCodeMutation } from "../../../../../newapi/oauth/oauthSlice";
import { RelationWebshopIntegrationCard } from "../../../../../components/global/cards/other/WebshopIntegrationCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetWebshopCredentialsQuery, useCreateWebshopFromInstallationMutation } from "../../../../../newapi/webshop/webshopSlice";
import { ReactComponent as BolLogo } from '../../../../../styles/svg/bol.svg';
import { ReactComponent as CcvshopLogo } from '../../../../../styles/svg/ccvshop.svg';
import { ReactComponent as LightspeedLogo } from '../../../../../styles/svg/lightspeed.svg';
import { ReactComponent as ApiLogo } from '../../../../../styles/svg/pin.svg';
import { ReactComponent as MagentoLogo } from '../../../../../styles/svg/magento.svg';
import { ReactComponent as ShopifyLogo } from '../../../../../styles/svg/shopify.svg';
import { ReactComponent as WooCommerceLogo } from '../../../../../styles/svg/woocommerce.svg';
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { getWebshopLogo } from "../../../../../utils/logomapper";
import { showToastMessageUpdateRequest, showToastMessageRequestError } from "../../../../../utils/toasts";
import SpEtailizeWebshopDetails from "../../../../../components/global/Sidepanels/SpEtailizeWebshopDetails/SpEtailizeWebshopDetails";
import ShDataGrid3 from "../../../../../components/theme/datagrid3/ShDataGrid3";

const SpWebshopCredentialsDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpWebshopCredentialsDetails/SpWebshopCredentialsDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {

    },[props.open]);
    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_saleschannel")}</Shbutton>
            )}
        </ButtonGroup>
    );
}


let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,

};

const All = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended,setIsExtended] = useState(false);
    const [isExtendedEtailize,setIsExtendedEtailize] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(1);
    const [rowSelected, setRowSelected] = useState(false);
    const [config, setConfig] = useState({"integrator": 0, "exclude_webshop_type": "api"});
    const [spLoading, setSpLoading] = useState();
    const [searchParams] = useSearchParams();

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_WEBSHOPCREDENTIALS_MANAGE])
    );

    const [createWebshopFromInstallation, { isLoading: isCreatingFromInstallation }] = useCreateWebshopFromInstallationMutation();

    // Helper function to get cookie value
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    };

    const [installationStarted, setInstallationStarted] = useState(false);

    // Handle Shopify installation flow
    useEffect(() => {
        const handleInstallation = async () => {
            if (installationStarted) return;
            setInstallationStarted(true);
            // First check URL parameters
            let shop = searchParams.get('shop');
            let code = searchParams.get('code');
            let type = searchParams.get('type');
            let state = searchParams.get('state');

            // Check if we came from localStorage (redirect scenario)
            const cameFromRedirect = localStorage.getItem("shopify_installation_shop") !== null;

            // If not in URL params, check cookies
            if (cameFromRedirect) {
                shop = localStorage.getItem("shopify_installation_shop");
                code = localStorage.getItem("shopify_installation_code");
                type = "shopify";

                const expires = new Date(localStorage.getItem("shopify_installation_expires"));

                localStorage.removeItem("shopify_installation_expires");
                localStorage.removeItem("shopify_installation_shop");
                localStorage.removeItem("shopify_installation_code");
                if (new Date() > expires) {
                    return;
                }
            }

            let installationData = null;
            // If we have the installation data, proceed with API call
            if (shop && code && type === 'shopify') {
                //try {
                    installationData = {
                        shop: decodeURIComponent(shop),
                        code: decodeURIComponent(code),
                        type: type
                    };
                    
            } else if(state && type === 'bol'){
                installationData = {
                    shop: decodeURIComponent(state),
                    code: decodeURIComponent(code),
                    type: type
                };
            }

            if(installationData){
                try {
                    const result = await createWebshopFromInstallation(installationData).unwrap();
                        showToastMessageUpdateRequest(t, result);
                        
                        // If we have result.data.id and came from redirect, refresh page with ID as URL param
                        if (result.data && result.data.id) {
                            const webshopId = result.data.id;
                            
                            if (cameFromRedirect) {
                                // Refresh page with webshop ID as URL parameter to avoid 401 issues
                                window.location.href = `${window.location.pathname}?webshop_id=${webshopId}`;
                                return;
                            } else {
                                // Normal flow - open sidepanel directly
                                const newWebshopCredentialsId = parseInt(result.data.id);
                                if (!spLoading) {
                                    setSpLoading(true);
                                }
                                setWebshopCredentialsId(newWebshopCredentialsId);
                                webshopCredentialsIdRef.current = newWebshopCredentialsId;
                                setIsExtended(true);
                            }
                        }
                        
                        // Optionally refresh the data grid or navigate
                        // The data grid should automatically refresh due to cache invalidation
                    } catch (error) {
                        if(error?.status !== 400 && error.status !== 404){
                            showToastMessageRequestError(t('installation_failed'), t, error);
                        }
                    }
                }
            };
            handleInstallation();
        },[searchParams]);

    const [amazonFinalize, setAmazonFinalize] = useState(null);

    useEffect(() => {
        const resumeId = searchParams.get('amazon_oauth_resume');
        const errorCode = searchParams.get('amazon_oauth_error');

        if (errorCode) {
            showToastMessageRequestError(t('amazon_connection_failed'), t, { status: errorCode });
            return;
        }

        if (resumeId) {
            fetch(`${config.url.API_BACKEND_URL}oauth/amazon/resume-session?id=${encodeURIComponent(resumeId)}`, {
                credentials: 'include',
            })
                .then(r => r.ok ? r.json() : Promise.reject(r))
                .then(({ refresh_token, selling_partner_id }) => {
                    setAmazonFinalize({
                        refreshToken: refresh_token,
                        sellingPartnerId: selling_partner_id,
                    });
                })
                .catch(() => {
                    showToastMessageRequestError(
                        t('amazon_connection_failed'), t, { status: 'resume_failed' },
                    );
                });
            return;
        }

        const callbackUri = localStorage.getItem('amazon_installation_callback_uri');
        if (!callbackUri) return;

        const amazonState = localStorage.getItem('amazon_installation_state');
        const sellingPartnerId = localStorage.getItem('amazon_installation_selling_partner_id');
        const expires = new Date(localStorage.getItem('amazon_installation_expires'));

        localStorage.removeItem('amazon_installation_callback_uri');
        localStorage.removeItem('amazon_installation_state');
        localStorage.removeItem('amazon_installation_selling_partner_id');
        localStorage.removeItem('amazon_installation_expires');

        if (new Date() > expires) return;

        const frontendState = (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

        const params = new URLSearchParams({
            amazon_callback_uri: callbackUri,
            amazon_state: amazonState,
            selling_partner_id: sellingPartnerId,
            state: frontendState,
        });
        window.location.href = `${config.url.API_BACKEND_URL}oauth/amazon/login-resume?${params.toString()}`;
    }, [searchParams]);

    const [tiktokFinalize, setTiktokFinalize] = useState(null);
    const tiktokExchangeStartedRef = useRef(false);
    const [exchangeTikTokCode] = useExchangeTikTokCodeMutation();

    useEffect(() => {
        const type = searchParams.get('type');
        const code = searchParams.get('code');

        if (type !== 'tiktokshop' || !code) return;
        if (tiktokExchangeStartedRef.current) return;
        tiktokExchangeStartedRef.current = true;

        exchangeTikTokCode({ code: decodeURIComponent(code) }).unwrap()
            .then((payload) => {
                setTiktokFinalize(payload);
            })
            .catch(() => {
                showToastMessageRequestError(t('tiktok_connection_failed'), t, { status: 'exchange_failed' });
            });
    }, [searchParams]);

    // const { data: credentialData, error, isLoading } = useGetWebshopCredentialsSingleQuery(
    //    selectedRowId,
    //     {
    //         skip: !rowSelected
    //     }
    // );
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };

      
    const [webshopCredentialsId, setWebshopCredentialsId] = useState();
    const webshopCredentialsIdRef = useRef(webshopCredentialsId);
    
    const getWebshopCredentialDetails = (params) => {
        if (!params) return;
    
        const newwebshopCredentialsId = parseInt(params.row.id);
        // Only update state if the webshopCredentialsId has actually changed
        if (webshopCredentialsIdRef.current !== newwebshopCredentialsId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setWebshopCredentialsId(newwebshopCredentialsId);
            webshopCredentialsIdRef.current = newwebshopCredentialsId; // Update the ref to the new value
        }
        if(params.row.integrator){
            setIsExtendedEtailize(true)
        } else {
            setIsExtended(true);
        }
    };

    // Function to open sidepanel with ID directly (for query parameter)
    const openSidepanelWithId = (id) => {
        if (!id) return;
        
        const webshopId = parseInt(id);
        if (webshopCredentialsIdRef.current !== webshopId) {
            if (!spLoading) {
                setSpLoading(true);
            }
            setWebshopCredentialsId(webshopId);
            webshopCredentialsIdRef.current = webshopId;
        }
        setIsExtended(true);
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions hasCreatePermission={hasCreatePermission} handleOpen={() => setAddModalOpen(true)}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    // Handle initial webshop ID from query parameter
    useEffect(() => {
        if (props.initialWebshopId) {
            openSidepanelWithId(props.initialWebshopId);
        }
    }, [props.initialWebshopId]);

    // Handle webshop_id URL parameter (for redirect scenarios)
    useEffect(() => {
        const webshopIdParam = searchParams.get('webshop_id');
        if (webshopIdParam) {
            openSidepanelWithId(webshopIdParam);
        }
    }, [searchParams]);
    
    
    const columns = [
        {field: "description", headerName: t("channel") , flex:2, cellClassName: "webshop", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }
            let name = cellValues.row.webshop_type;
            if(cellValues.row.webshop_type === "etailize") {
                name = cellValues.row.credentials || cellValues.row.webshop_type;
            }
            const webshopLogo = getWebshopLogo(cellValues.row.webshop_type,{theme,colors},name);
            return (
                <>
                <Box sx={{ paddingRight: '10px' }}>
                    {webshopLogo}
                </Box>
                <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{cellValues.value}</Text>
                </>
            )
        }},
        {field: "warehouse", headerName: t("warehouse") , flex:2, cellClassName: "warehouse", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text  >{cellValues.value?.name}</Text>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RelationWebshopIntegrationCard onClick={() => getWebshopCredentialDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}/>
                )
                // console.log(cellValues.row);
               // return (
                    // <AllCarriersCard {...cellValues.row} />
               // )
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const labelColor = params.row.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey";
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelColor}>
                      {t(params.row.state)}
                    </ShLabel>
                  );
              }
        },
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid3 
                gridKey="relations.integrations.webshops.direct"
                disableViewSaving
                key={theme.palette.mode}
                content={useGetWebshopCredentialsQuery}
                config={config}
                gridActions={<GridActions hasCreatePermission={hasCreatePermission} handleOpen={() => setAddModalOpen(true)}></GridActions>} 
                title={t("saleschannels")}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns}
                rows={data}
                onRowClick={getWebshopCredentialDetails}>
            </ShDataGrid3>


            <MpAddWebshop onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>
            {amazonFinalize && (
                <MpAmazonOAuthFinalize
                    open={!!amazonFinalize}
                    handleClose={() => setAmazonFinalize(null)}
                    refreshToken={amazonFinalize.refreshToken}
                    sellingPartnerId={amazonFinalize.sellingPartnerId}
                />
            )}
            {tiktokFinalize && (
                <MpTikTokOAuthFinalize
                    open={!!tiktokFinalize}
                    handleClose={() => setTiktokFinalize(null)}
                    payload={tiktokFinalize}
                />
            )}


            {spLoading &&
                    <SpWebshopCredentialsDetails
                        isExtended={isExtended}
                        setIsExtended={setIsExtended}
                        webshopCredentialsId={webshopCredentialsId}
                        // data={credentialData} 
                    />
            }

            {spLoading && 
                <SpEtailizeWebshopDetails
                    isExtended={isExtendedEtailize}
                    setIsExtended={setIsExtendedEtailize}
                    etailizeWebshopId={webshopCredentialsId}
                    // data={credentialData} 
                /> 
            }
        </Box>
    )
};

export default All;